import * as types from './mutation-types';

export const mutations = {
  [types.SAVE_NETWORK](state, data) {
    state.network = data;
  },
  [types.SAVE_STATIC](state, data) {
    state.staticData = data;
  },
  [types.SAVE_LEGEND_COLORS](state, data) {
    state.legend = data;
  },
  [types.SAVE_TECHNOLOGY](state, data) {
    state.technology = data;
  },
  [types.SAVE_LOCATION](state, data) {
    state.location = data;
  },
  [types.SAVE_DISCLAIMER](state, data) {
    state.disclaimer = data;
  },
  [types.SAVE_FAQ](state, data) {
    state.faq = data;
  },
  [types.SAVE_CURRENT_COVERAGE](state, data) {
    state.currentCoverage = data;
  },
  [types.SAVE_BOUNDS](state, data) {
    state.bounds = data;
  },
  [types.SAVE_ZOOM](state, data) {
    state.zoom = data;
  },
  [types.SAVE_LOCATION_COVERAGE](state, data) {
    state.locationCoverage.items = data.items;
  },
  [types.CHANGE_LOCATION_COVERAGE_MODAL_STATE](state, openValue) {
    state.locationCoverage.isOpen = openValue;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/map/mutations.js